<template>
   <div class="Rating-gray">
     <i v-for="(item,index) in itemClasses" :key="index" @mouseout="outStar(index)" @mouseover="hoverStar(index)"  class="icon iconfont" :class="item">&#xe870;</i>
   </div>
</template>

<script>
const LENGTH = 5;
export default {
  name:"Rating",
  props:{
    rating:Number,//目前是几星
  },
  data(){
    return{
      starNum:0,//当前星级是几级
    }
  },
  created(){
    this.posStar();
  },
  computed:{
    itemClasses(){
      let result = [];
      while(result.length < LENGTH) {
        result.push({});
      };
      return result;
    }
  },
  methods:{
    //经过事件
    hoverStar(key){
      console.log(key,'==5666==');
      $('.Rating-gray .icon:gt('+key+')').css('color','#eee');
      $('.Rating-gray .icon:lt('+(key+1)+')').css('color','#ffbe00');
    },
    //鼠标离开事件
    outStar(key){
      this.posStar(key);
    },
    //点击事件
    // changeStar(key){
    //   this.starNum = key;
    //   this.$emit('changeStar',key+1);
    //   this.posStar();
    // },
    //定位到几星 1-5
    posStar(level){
      console.log(level)
      if(level){
        this.starNum = level;
        this.$emit('changeStar',level+1);
      }else if(this.rating){
        this.starNum = this.rating - 1;
      }else{
        this.starNum = 0;
      }
      if(this.starNum){
            // this.hoverStar(this.starNum);
      }else{
        $('.Rating-gray .icon:lt('+(1)+')').css('color','#ffbe00');
      }
    }
  }
}
</script>

<style scoped>
.Rating-gray {
  display: inline-block;
}
.Rating-gray .icon{
  cursor:pointer;
 /* color: #ffbe00; */
 color:#eee;
}
</style>
